var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Notes"},[_c('ckeditor',{attrs:{"editor":_vm.editor,"config":_vm.editorConfig},model:{value:(_vm.textNotes),callback:function ($$v) {_vm.textNotes=$$v},expression:"textNotes"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }